import i18n from '@/locale/index'

export default [
  {
    path: '/mapActivity',
    name: 'mapActivity',
    component: () => import('../../views/mapActivity/index.vue'),
    meta: {
      title: i18n.global.t('points.c5')
    }
  }
]
